module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vsidebar', {
      show: _vm.showSideBar
    }]
  }, [_c('div', {
    staticClass: "login"
  }, [(_vm.user.loginname) ? _c('router-link', {
    attrs: {
      "to": "/me",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.avatar_url,
      "alt": "用户头像"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user && _vm.user.loginname))])]) : _c('router-link', {
    attrs: {
      "to": "/login",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/unlogin.jpg"),
      "alt": "unlogin.jpg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s('点此登录'))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "topics"
  }, [_c('ul', {
    on: {
      "click": _vm.hide
    }
  }, [_c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'all'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("全部")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'good'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("精华")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'share'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("分享")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'ask'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("问答")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'job'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("招聘")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('router-link', {
    attrs: {
      "to": "/about",
      "tag": "span"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("关于")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-054b4266"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 132
// module chunks = 1